import React, { useEffect } from "react";
import CustomInput from "common/components/CustomInput/CustomInput.jsx";

const EasyMACaddress = (props) => {
  const { propName } = props;
  const setPropMounted = props.connectForm.setPropMounted;

  useEffect(() => {
    setPropMounted(propName, true);
    return () => {
      setPropMounted(propName, false);
    };
  }, [setPropMounted, propName]);

  function transformMACaddress(value) {
    let returnValue = value;

    returnValue = returnValue.toLowerCase();

    if (returnValue.length > 17) {
      return returnValue.slice(0, 17);
    }

    if (/[^a-f0-9]/.test(returnValue.slice(-1))) {
      return returnValue.slice(0, -1);
    }

    if (/^.{3}$/.test(returnValue)) {
      return returnValue.slice(0, 2) + ":" + returnValue.slice(2);
    }

    if (/^.{6}$/.test(returnValue)) {
      return returnValue.slice(0, 5) + ":" + returnValue.slice(5);
    }

    if (/^.{9}$/.test(returnValue)) {
      return returnValue.slice(0, 8) + ":" + returnValue.slice(8);
    }

    if (/^.{12}$/.test(returnValue)) {
      return returnValue.slice(0, 11) + ":" + returnValue.slice(11);
    }

    if (/^.{15}$/.test(returnValue)) {
      return returnValue.slice(0, 14) + ":" + returnValue.slice(14);
    }

    return returnValue;
  }

  return (
    <CustomInput
      success={props.connectForm.getState(propName) === "Success"}
      error={props.connectForm.getState(propName) === "Error"}
      labelText={
        <span>
          {props.connectForm.getLabel(propName) + " "}
          {props.connectForm.isRequired(propName) ? (
            <span style={{ color: "red" }}>*</span>
          ) : (
            ""
          )}
        </span>
      }
      id={propName}
      formControlProps={{
        fullWidth: true,
      }}
      inputProps={{
        onChange: (event) =>
          props.connectForm.change(
            transformMACaddress(event.target.value),
            propName
          ),
        value: props.connectForm.getValue(propName),
        autoComplete: "off",
      }}
    />
  );
};

export default EasyMACaddress;
